module.exports = __webpack_public_path__ + "img/whats-on.91092397.png";